import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@hmsexp/component-library';
import ContentLoader from '../../../../components/Common/LoadingComp/ContentLoader';
import RectLoader from '../../../../components/Common/LoadingComp/RectLoader';

const AlertSummaryLoader = () => {
  const { palette } = useTheme();

  const summaryBars = [
    { start: 55, width: 8 },
    { start: 64, width: 8 },
    { start: 73, width: 8 },
    { start: 82, width: 8 },
    { start: 91, width: 8 }
  ];

  const tableColumns = {
    label: { start: 0, width: 35 },
    metrics: [
      { start: 38, width: 11 },
      { start: 51, width: 11 },
      { start: 64, width: 11 },
      { start: 77, width: 11 },
      { start: 90, width: 10 }
    ]
  };

  const rows = 5;
  const rowHeight = 30;
  const rowGap = 20;
  const totalHeight = rows * (rowHeight + rowGap);

  return (
    <View style={{ padding: 12 }}>
      <ContentLoader
        height={28}
        backgroundColor={palette.primaryBackgroundLow}
        foregroundColor={palette.primaryOutline}
        style={{ marginBottom: 20 }}>
        {summaryBars.map((bar, idx) => (
          <RectLoader key={idx} x={`${bar.start}%`} y='8' width={`${bar.width}%`} height='12' rx='6' ry='6' />
        ))}
      </ContentLoader>

      <ContentLoader
        height={totalHeight}
        backgroundColor={palette.primaryBackgroundLow}
        foregroundColor={palette.primaryOutline}>
        {Array.from({ length: rows }).map((_, row) => {
          const y = row * (rowHeight + rowGap);

          return (
            <React.Fragment key={row}>
              <RectLoader
                x={`${tableColumns.label.start}%`}
                y={y}
                width={`${tableColumns.label.width}%`}
                height={rowHeight}
                rx='6'
                ry='6'
              />

              {tableColumns.metrics.map((col, idx) => (
                <RectLoader
                  key={`${row}-${idx}`}
                  x={`${col.start}%`}
                  y={y}
                  width={`${col.width}%`}
                  height={rowHeight}
                  rx='6'
                  ry='6'
                />
              ))}
            </React.Fragment>
          );
        })}
      </ContentLoader>
    </View>
  );
};

export default AlertSummaryLoader;